import React from 'react'
import { camelCase } from 'lodash'
import BusinessSource from 'components/BusinessSource'
import styles from './BusinessDataSources.scss'

export interface IBusinessType {
  name: string
}

export interface IBusiness {
  dataSources: Array<string>
  urls?: Array<string>
}

function BusinessDataSources({ dataSources, urls }: IBusiness) {
  const sourceClick = (index: number) => {
    window.open(urls?.[index], '_blank')
  }

  return (
    <ul className={styles.sources}>
      {dataSources.map((source: string, index: number) => {
        const hasUrl = !!urls?.[index]
        return (
          <li
            key={index}
            className={hasUrl ? styles.clickable : ''}
            onClick={() => (hasUrl ? sourceClick(index) : null)}
          >
            <BusinessSource source={camelCase(source)} isDisabled={!hasUrl} isClickable={hasUrl} />
          </li>
        )
      })}
    </ul>
  )
}

export default BusinessDataSources
